import { MySoftiesHeadingWrap } from '../../MySofties.styles';

const MySoftiesHeading = ({ titlePrefix, titleHighlight }) => (
	<MySoftiesHeadingWrap>
		<h2>
			{titlePrefix} <span>{titleHighlight}</span>
		</h2>
	</MySoftiesHeadingWrap>
);

export default MySoftiesHeading;
